/**
 * Звук у роликов карточек: один выбор человека на всю сессию.
 *
 * Мест, где ролик может звучать, несколько (лайтбокс «глазика», превью карточки
 * в виджете), и у каждого свой РАЗУМНЫЙ умолчание: лайтбокс человек открыл сам
 * и ждёт полноценный просмотр — там звук включён; превью в виджете играет
 * фоном — там тихо, пока не нажали динамик. А вот ЯВНЫЙ выбор общий: включил
 * звук в одном месте — не надо включать его снова в соседнем, и наоборот.
 *
 * sessionStorage, а не localStorage: «хочу со звуком» — настроение этого
 * захода, а не постоянная настройка аккаунта.
 */
const KEY = 'card-sound'

/** true — человек попросил звук, false — попросил тишину, null — не выбирал. */
export function soundPref(): boolean | null {
	try {
		const v = sessionStorage.getItem(KEY)
		return v === null ? null : v === '1'
	} catch {
		// Приватный режим/заблокированное хранилище — просто живём без памяти.
		return null
	}
}

export function setSoundPref(on: boolean): void {
	try {
		sessionStorage.setItem(KEY, on ? '1' : '0')
	} catch {
		/* см. выше */
	}
}
